import type {Auth} from 'typings/portaro.be.types';
import type ModalConversationService from '../../modals/modal-conversation.service';
import type {PayloadActionResponse} from 'typings/portaro.fe.types';
import type {LoginDataService} from 'shared/login/kp-login/kp-login.data-service';

export default class MainLoginFormService {
    public static serviceName = 'mainLoginFormService';

    /*@ngInject*/
    constructor(private modalConversationService: ModalConversationService,
                private loginDataService: LoginDataService) {
    }

    public async openForm(): Promise<Auth> {
        const loginSuccessResponse = await this.openModalLoginForm();
        return loginSuccessResponse.payload;
    }

    private async openModalLoginForm(): Promise<PayloadActionResponse<Auth>> {
        const loginView = await this.loginDataService.getLoginView()
        return this.modalConversationService.openModalWindowAndGetFinishedResponse<PayloadActionResponse<Auth>>('loginForm', loginView);
    }
}
